import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { shareBook } from '../utils/shareBook';
import { URL } from "../utils/constants";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Wishlist from './Wishlist';
import { NavLink } from 'react-router-dom';

export default function BookModal({
    showModal,
    closeModal,
    loadingBook,
    selectedBook,
    handleShare,
    renderStars,
    handleBookID,
    handlePopupAuthorClick,
    handlePopupPublisherClick,
    handleInstantRemove,
    handleActionClick
}) {


    useEffect(() => {
        if (showModal) {
            setTimeout(() => {
                AOS.refreshHard();
            }, 50);
        }
    }, [showModal]);

    const onAuthorClick = () => {
        handlePopupAuthorClick(selectedBook);
    };

    const onPublisherClick = () => {
        handlePopupPublisherClick(selectedBook);
    };

    if (loadingBook) {
        return (
            <div className='modal_backdrop'>
                <div className="d-flex justify-content-center align-items-center">
                    <div className="spinner-border text-white" role="status"></div>
                </div>
            </div>
        );
    }



    if (!selectedBook) return null;

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                theme="dark"
            />
            <div className="modal my_modal" style={{ display: showModal ? 'block' : 'none' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                        <button className="modal-close icofont-close" onClick={closeModal}></button>
                        <div className="product-view">
                            <div className="col-md-12 col-lg-12">
                                <div className="share-button mt-2"></div>

                                <div className="row view-gallery">
                                    {/* Cover Image / Video */}
                                    <div className='col-md-4 col-5'>
                                        {selectedBook?.video_url ? (
                                            <video
                                                src={`${URL}/${selectedBook.video_url}`}
                                                className="img-fluid mb-3 w-100"
                                                controls
                                                poster={`${URL}/${selectedBook?.book_cover_img}` || "https://ndl.education.gov.in/upload/book_place_holder.jpg"}
                                            />
                                        ) : (
                                            <img
                                                src={`${URL}/${selectedBook?.book_cover_img}` || "https://ndl.education.gov.in/upload/book_place_holder.jpg"}
                                                alt="Book Cover"
                                                className="img-fluid mb-3 w-100"
                                            />
                                        )}
                                    </div>

                                    {/* Book Info */}
                                    <div className='col-md-8 col-7'>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className='d-flex justify-content-between'>
                                                    <h3 className="view-name">{selectedBook.book_title}</h3>

                                                </div>

                                                <div className='moddal_rating_info d-flex justify-content-between'>
                                                    <div className='d-flex align-items-center' onClick={() => handleBookID(selectedBook.id)} role='button'>
                                                        {renderStars(selectedBook.avg_rating)}
                                                        <h4 className="info-ans ms-2">{selectedBook.avg_rating.toFixed(1)}</h4>
                                                    </div>
                                                    <div className=''>
                                                        {/* <Wishlist
                                                            bookId={selectedBook.id}
                                                            bookTitle={selectedBook.book_title}
                                                            onRemove={handleInstantRemove}
                                                            onCloseModal={closeModal}
                                                        />  */}
                                                        <button className="btn f_increase view-all-btnn ms-3 d-none" onClick={() => shareBook(selectedBook)}>
                                                            <i class="fas fa-share-alt square_btn"></i>
                                                        </button>
                                                        <button className="btn f_increase view-all-btnn ms-2" onClick={() => handleShare(selectedBook)}>
                                                            <i class="fas fa-share-alt square_btn"></i>
                                                        </button>
                                                    </div>

                                                    {/*  <button className="btn f_increase view-all-btnn ms-3 d-none" onClick={() => shareBook(selectedBook)}>
                                                    <i class="fas fa-share-alt square_btn"></i>
                                                </button> */}
                                                </div>
                                            </div>

                                            {/* Table Info */}
                                            <div className='col-md-12'>
                                                <div className="table_modal">
                                                    {selectedBook.author_name && (
                                                        <div className="info-authors">
                                                            <div className='moddal_info'>
                                                                <h4 className="info-ttl">
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/authors.png`} alt="authors" />
                                                                    <span className='desktop-view'>Authors</span>
                                                                </h4>
                                                                <h4 className="info-ans pointer_css" onClick={onAuthorClick}>{selectedBook.author_name}</h4>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {selectedBook.publisher_name && (
                                                        <div className="info-authors">
                                                            <div className='moddal_info'>
                                                                <h4 className="info-ttl">
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/publications.png`} alt="publications" />
                                                                    <span className='desktop-view'>Publisher</span>
                                                                </h4>
                                                                <h4 className="info-ans pointer_css" onClick={onPublisherClick}>{selectedBook.publisher_name}</h4>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {selectedBook.age_group && (
                                                        <div className="info-authors">
                                                            <div className='moddal_info'>
                                                                <h4 className="info-ttl">
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/age-group.png`} alt="Age-Group" />
                                                                    <span className='desktop-view'>Age Group</span>
                                                                </h4>
                                                                <h4 className="info-ans">{selectedBook.age_group}</h4>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {selectedBook.book_category && (
                                                        <div className="info-authors">
                                                            <div className='moddal_info'>
                                                                <h4 className="info-ttl">
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/Genre.png`} alt="Genre" />
                                                                    <span className='desktop-view'>Genre </span>
                                                                </h4>
                                                                <h4 className="info-ans">{selectedBook.book_category}</h4>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {selectedBook.book_language && (
                                                        <div className="info-authors">
                                                            <div className='moddal_info'>
                                                                <h4 className="info-ttl">
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/language.png`} alt="language" />
                                                                    <span className='desktop-view'>Language</span>
                                                                </h4>
                                                                <h4 className="info-ans">{selectedBook.book_language}</h4>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {selectedBook.book_year && (
                                                        <div className="info-authors">
                                                            <div className='moddal_info'>
                                                                <h4 className="info-ttl">
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/years.png`} alt="years" />
                                                                    <span className='desktop-view'>Book Year</span>
                                                                </h4>
                                                                <h4 className="info-ans">{selectedBook.book_year}</h4>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {selectedBook.book_pages && (
                                                        <div className="info-authors">
                                                            <div className='moddal_info'>
                                                                <h4 className="info-ttl">
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/pages.png`} alt="pages" />
                                                                    <span className='desktop-view'>page count</span>
                                                                </h4>
                                                                <h4 className="info-ans">{selectedBook.book_pages}</h4>
                                                            </div>
                                                        </div>
                                                    )}


                                                    {selectedBook.download_count != null && (
                                                        <div className="info-authors">
                                                            <div className='moddal_info'>
                                                                <h4 className="info-ttl">
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/download_count.png`} alt="download count" />
                                                                    <span className='desktop-view'>Download Count</span>
                                                                </h4>
                                                                <h4 className="info-ans">{selectedBook.download_count}</h4>
                                                            </div>
                                                        </div>
                                                    )}


                                                </div>
                                            </div>

                                            <div className="info-authorss mt-3 text-end">
                                                <button onClick={handleActionClick} className='btn-6 view-all-btnn mb-3'>
                                                    Start Reading <i className="fas fa-long-arrow-alt-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>


                                    <div className='col-md-12'>
                                        <div className="view-details">
                                            <h3 className="view-name">Book Summary</h3>
                                            <p className="view-desc">{selectedBook.book_desc}</p>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}


